const pilotareas = [{"key":"pilotarea.vienna","string":"Dunaj"},{"key":"pilotarea.bratislava","string":"Bratislava – Hainburg – Kittsee"},{"key":"pilotarea.vogtland","string":"Vogtland \/Zahodna Češka"},{"key":"pilotarea.ljubljana","string":"Ljubljana"},{"key":"pilotarea.broumov","string":"Walbrzych \/ Broumov"},{"key":"pilotarea.krakow","string":"Krakov"},{"key":null,"string":null}]

export default pilotareas



// WEBPACK FOOTER //
// ./src/i18n/sl/pilotareas/_pilotareas.js